import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartners } from "../../redux/slices/partnersSlice";
import { marchanticon } from "../../assets/ImageExports";
import "./marchantlist.css";
import ErrorPage from "../error/ErrorPage";

const statusColor = {
  Pending: "warning",
  Approved: "success",
  Rejected: "danger",
  Processing: "primary"
};

const getStatus = (member_active) => {
  if (member_active === 1) return "Approved";
  if (member_active === 2) return "Pending";
  if (member_active === 3) return "Processing";
  if (member_active === 0) return "Rejected";
  return "Pending";
};

const Businesspartner = () => {
  const dispatch = useDispatch();
  const { partners, loading, error } = useSelector((state) => state.partnerlist);
  const partnerlist = partners.partners;

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil((partnerlist?.length || 0) / itemsPerPage);
  const currentData = partnerlist?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  useEffect(() => {
    dispatch(fetchPartners());
  }, [dispatch]);

  const openModal = (company) => {
    setSelectedCompany(company);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedCompany(null);
    setShowModal(false);
  };

  return (
    <div className="card p-4 shadow-sm rounded-4">
      <h4 className="mb-4" style={{ color: "#0065F8", fontWeight: "bold" }}>
        Merchant List
      </h4>

      {loading && <p>Loading merchants...</p>}
      {error && <ErrorPage />}

      <div className="table-responsive">
        <table className="table table-hover table-striped align-middle text-center">
          <thead className="table-light">
            <tr>
              <th>Icon</th>
              <th>Partner Name</th>
              <th>Email</th>
              <th>Address</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(currentData) && currentData.length > 0 ? (
              currentData.map((partner, idx) => (
                <tr key={idx}>
                  <td>
                    <img src={marchanticon} alt="icon" className="rounded-circle" style={{ height: 40 }} />
                  </td>
                  <td>{partner.member_contact_name || "N/A"}</td>
                  <td>{partner.member_email || "N/A"}</td>
                  <td>{partner.member_firm_address || "N/A"}</td>
                  <td>
                    <span className={`badge bg-${statusColor[getStatus(partner.member_active)]}`}>
                      {getStatus(partner.member_active)}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => openModal(partner)}>
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No merchants found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3 flex-wrap gap-2">
          <button
            className="btn btn-outline-primary"
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`btn ${currentPage === idx + 1 ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
          <button
            className="btn btn-outline-primary"
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {showModal && selectedCompany && (
        <>
          <div className="custom-modal-wrapper modal d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content rounded-4 shadow">
                <div className="modal-header bg-light border-bottom-0">
                  <h5 className="modal-title">
                    Company Details - <span className="text-primary">{selectedCompany.member_firm_name}</span>
                  </h5>
                  <button type="button" className="btn-close" onClick={closeModal}></button>
                </div>
                <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                  <div className="row">
                    {[
                      ["Firm Address", selectedCompany.member_firm_address],
                      ["Owner Name", selectedCompany.member_contact_name],
                      ["Email", selectedCompany.member_email],
                      ["Phone", selectedCompany.member_mobile],
                      ["PAN", selectedCompany.member_pan],
                      ["Aadhar", selectedCompany.member_aadhar],
                      ["Account No", selectedCompany.member_account],
                      ["IFSC", selectedCompany.member_ifsc],
                      ["Business Type", selectedCompany.member_business_type],
                      ["City", selectedCompany.member_city],
                      ["State", selectedCompany.member_state],
                      ["Pin Code", selectedCompany.member_pin],
                      ["Service Email", selectedCompany.member_service_emails]
                    ].map(([label, value], i) => (
                      <div className="col-md-6 mb-3" key={i}>
                        <strong>{label}:</strong> <br />
                        {value || "N/A"}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer border-top-0">
                  <button className="btn btn-secondary" onClick={closeModal}>Close</button>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-modal-backdrop" onClick={closeModal}></div>
        </>
      )}
    </div>
  );
};

export default Businesspartner;
